"use client";

import { useEffect } from "react";

// Using the same logos as in the company showcase
const logos = [
  { name: "Raydium", image: "/assets/raydium.svg" },

  { name: "Jupiter", image: "/assets/jupiter.svg" },
  // { name: "Helio", image: "/assets/helio.svg" },

  { name: "Moonwalk", image: "/assets/moonwalk.svg" },
  { name: "Kamino", image: "/assets/kamino.svg" },
  { name: "MarginFi", image: "/assets/marginfi.svg" },
  { name: "Orca", image: "/assets/orca.svg" },
];

export function SocialProofSection() {
  return (
    <section className="flex flex-col items-center justify-center w-full relative py-12">
      <div className="w-full max-w-6xl mx-auto px-4">
        <h2 className="text-center text-gray-400 text-xl font-medium uppercase tracking-wider mb-10">
          OUR PARTNERS
        </h2>
        
        <div className="logo-carousel relative overflow-hidden">
          <div className="logos-slide flex items-center justify-around">
            {logos.concat(logos).map((logo, index) => (
              <div 
                key={`logo-${index}`} 
                className="mx-8 flex-shrink-0"
              >
                <img
                  src={logo.image}
                  alt={logo.name}
                  className={`${
                    logo.name === "Moonwalk" 
                      ? "h-24 w-auto scale-160" 
                      : "h-20 w-auto"
                  } opacity-90 hover:opacity-100 transition-opacity duration-300 invert`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <style jsx global>{`
        .logo-carousel {
          position: relative;
          max-width: 100%;
          mask-image: linear-gradient(
            to right,
            transparent,
            black 10%,
            black 90%,
            transparent
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent,
            black 10%,
            black 90%,
            transparent
          );
        }
        
        .logos-slide {
          animation: slide 25s linear infinite;
          width: calc(250px * ${logos.length * 2});
        }
        
        @keyframes slide {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          .logos-slide {
            animation: none;
          }
        }
      `}</style>
    </section>
  );
}
  